import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {T} from 'Actions/translate';

class SimpleMenu extends React.Component {
    state = {
        anchorEl: null,
    };

    handleClick = (event) => {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        } else {
            window.event.cancelBubble = true;
        }
        this.setState({anchorEl: event.currentTarget});
    };

    handleFirstRowBtn = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({anchorEl: null});
        this.props.firstRowHandle();
    };

    handleSecondRowBtn = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({anchorEl: null});
        this.props.secondRowHandle();
    };

    handleThirdRowBtn = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({anchorEl: null});
        this.props.thirdRowHandle();
    };

    handleClose = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({anchorEl: null});
    };

    phoneClick = (e) => {
        e.stopPropagation();
    };

    render() {
        const {anchorEl} = this.state;
        const {className, orderStatus} = this.props;

        return (
            <div className="more-btn-div">
                <Button
                    className={className}
                    testid="shipment-preview-more-button"
                    aria-owns={anchorEl ? 'simple-menu' : null}
                    aria-controls={Boolean(anchorEl) ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
                    onTouchStart={this.phoneClick}
                    onClick={this.handleClick}>
                    {T('shipment_preview_more')}
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}>
                    {orderStatus === 1 || orderStatus === 2 ? (
                        <MenuItem
                            testid="shippment-delivery-details"
                            onTouchStart={this.phoneClick}
                            onClick={this.handleFirstRowBtn}>
                            {T('shippment_delivery_details')}
                        </MenuItem>
                    ) : (
                        ''
                    )}
                    {orderStatus === 1 ? (
                        <MenuItem
                            testid="shippment-temporary-not-delivery"
                            onTouchStart={this.phoneClick}
                            onClick={this.handleSecondRowBtn}>
                            {T('shippment_temporary_not_delivery')}
                        </MenuItem>
                    ) : (
                        ''
                    )}
                    {orderStatus === 2 ? (
                        <MenuItem
                            testid="to-send-the-goods"
                            onTouchStart={this.phoneClick}
                            onClick={this.handleThirdRowBtn}>
                            {T('to_send_the_goods')}
                        </MenuItem>
                    ) : (
                        ''
                    )}
                    {orderStatus === 3 ? (
                        <MenuItem
                            testid="shippment-add-tracking-number"
                            onTouchStart={this.phoneClick}
                            onClick={this.handleFirstRowBtn}>
                            {T(this.props.firstRowLabel)}
                        </MenuItem>
                    ) : (
                        ''
                    )}
                    {orderStatus === 3 && this.props.secondRowHandle ? (
                        <MenuItem
                            testid="shippment-query-coa"
                            onTouchStart={this.phoneClick}
                            onClick={this.handleSecondRowBtn}>
                            {T(this.props.secondRowLabel)}
                        </MenuItem>
                    ) : (
                        ''
                    )}
                    {orderStatus === 3 ? (
                        <MenuItem
                            testid="shippment-customer-feedback"
                            onTouchStart={this.phoneClick}
                            onClick={this.handleThirdRowBtn}>
                            {T(this.props.thirdRowLabel)}
                        </MenuItem>
                    ) : (
                        ''
                    )}
                </Menu>
            </div>
        );
    }
}

export default SimpleMenu;
